var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-button',_vm._b({},'el-radio-button',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }